// removed by extract-text-webpack-plugin
module.exports = {"site-branding":"site-branding","site-branding__link":"site-branding__link"};


//////////////////
// WEBPACK FOOTER
// ./resources/css/scss/4-objects/_branding.scss
// module id = 13
// module chunks = 0